import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { CheckboxGroup } from "rsuite";

// Create a separate component for the Twitter timeline
// This allows React to completely unmount and remount the component when teamId changes
const TwitterTimeline = ({ handle }: { handle: string }) => {
  const [loaded, setLoaded] = useState(false);
  console.log(handle);
  useEffect(() => {
    // Load Twitter widget script
    const loadScript = () => {
      // Check if script already exists
      if (document.getElementById("twitter-widget-script")) {
        if (window && (window as any).twttr) {
          setTimeout(() => {
            (window as any).twttr.widgets.load();
            setLoaded(true);
          }, 100);
        }
        return;
      }

      const script = document.createElement("script");
      script.id = "twitter-widget-script";
      script.src = "https://platform.twitter.com/widgets.js";
      script.async = true;
      script.charset = "utf-8";

      script.onload = () => {
        if (window && (window as any).twttr) {
          setTimeout(() => {
            (window as any).twttr.widgets.load();
            setLoaded(true);
          }, 100);
        }
      };

      document.body.appendChild(script);
    };

    loadScript();

    // No cleanup - we want to keep the Twitter script loaded
    // This avoids the removeChild errors
  }, []);

  return (
    <Box sx={{ mt: 1, height: "700px", overflow: "auto" }}>
      <a
        className="twitter-timeline"
        href={`https://twitter.com/${handle}?ref_src=twsrc%5Etfw`}
        data-tweet-limit="3"
      >
        {loaded ? "" : `Loading tweets from ${handle}...`}
      </a>
    </Box>
  );
};

const XFeed = ({ teamId }: { teamId: string }) => {
  // Use the teamId directly as the key to force complete remount when it changes
  return (
    <Box sx={{ py: 1 }}>
      <Typography variant="h6">XFeed</Typography>
      {/* Using teamId as key forces complete unmount/remount when teamId changes */}
      <TwitterTimeline key={teamId} handle={teamId} />
    </Box>
  );
};

export default XFeed;
